import { TTranscriptReviewProposal } from '../types';

export const splitTranscriptLines = (transcript: string): string[] => transcript.split('\n');

export const getLineCount = (transcript: string): number => splitTranscriptLines(transcript).length;

export const applyProposalPatch = (transcript: string, proposal: TTranscriptReviewProposal) => {
  const lines = splitTranscriptLines(transcript);
  const errors: string[] = [];
  const changedLines: number[] = [];

  for (const change of proposal.patch.changes ?? []) {
    const lineIndex = change.line - 1;

    if (lineIndex < 0 || lineIndex >= lines.length) {
      errors.push(`Line ${change.line} is outside transcript bounds`);
      continue;
    }

    if (lines[lineIndex] !== change.expectedText) {
      errors.push(`Line ${change.line} no longer matches expected text`);
      continue;
    }

    lines[lineIndex] = change.text;
    changedLines.push(change.line);
  }

  return { transcript: lines.join('\n'), errors, changedLines };
};
